import { motion } from "framer-motion";
import { MessageCircle, Phone } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL, openWhatsApp } from "@/data/content";

const CtaBanner = () => {
  return (
    <section data-testid="cta-section" className="relative overflow-hidden bg-[#1731cf] py-24 lg:py-32">
      <div className="absolute -left-40 top-1/2 -translate-y-1/2 w-[460px] h-[460px] rounded-full border border-white/10" />
      <div className="absolute -right-40 top-1/2 -translate-y-1/2 w-[460px] h-[460px] rounded-full border border-white/10" />
      <div
        className="absolute inset-0 opacity-50"
        style={{
          background:
            "radial-gradient(circle at 80% 30%, rgba(96,150,255,0.4), transparent 45%)",
        }}
      />

      <div className="relative max-w-3xl mx-auto px-5 lg:px-8 text-center">
        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-white tracking-tight leading-tight"
        >
          Peça seu botijão <span className="text-[#a3e635]">sem sair de casa</span>
        </motion.h2>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.1 }}
          className="text-white/75 text-lg sm:text-xl mt-6 max-w-xl mx-auto"
        >
          Entrega rápida e segura em toda Ipatinga. Escolha o canal que preferir.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="flex flex-wrap justify-center gap-4 mt-10"
        >
          <button
            data-testid="cta-whatsapp-btn"
            onClick={() => openWhatsApp()}
            className="flex items-center gap-3 bg-[#a3e635] hover:bg-[#92d420] text-[#0f1733] font-bold text-lg px-8 py-4 rounded-2xl shadow-xl shadow-[#a3e635]/30 transition-all hover:-translate-y-1"
          >
            <MessageCircle className="w-6 h-6" /> WhatsApp
          </button>
          <a
            href={`tel:${PHONE_TEL}`}
            data-testid="cta-phone-btn"
            className="flex items-center gap-3 bg-white/10 hover:bg-white/20 backdrop-blur-sm border border-white/20 text-white font-bold text-lg px-8 py-4 rounded-2xl transition-all hover:-translate-y-1"
          >
            <Phone className="w-5 h-5" /> Disk-Gás: {PHONE_DISPLAY}
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default CtaBanner;
